import { twMerge } from "tailwind-merge";

const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join("");

const UserAvatar: React.FunctionComponent<{
  name?: string;
  /** Overrides the default size, e.g. "h-14 w-14 text-xl". */
  className?: string;
}> = ({ name, className }) => (
  <span
    className={twMerge(
      "grid h-8 w-8 shrink-0 place-content-center rounded-full bg-gradient-to-br from-primary-2 to-primary-1 text-xs font-bold text-white",
      className,
    )}
    aria-hidden="true"
  >
    {initials(name)}
  </span>
);

export default UserAvatar;
